import { extendBillingInfo } from '@sdk/account/utils';

export default function Subscription(Restangular) {
  'ngInject';

  Restangular.extendModel('account/org/subscription', (billingInfo) => {
    return extendBillingInfo(billingInfo);
  });

  return Restangular.service('account/org/subscription');
}
